export const additionalFilterFormFields = [
	'builder',
	'project',
	'customer',
	'type',
	'requirements',
	'createdAt',
	'createdBy',
	'targetAt',
	'dueAt',
	'assignedTo',
	'owner',
	'salesPerson',
] as const;

export const filterFormFields = [
	'searchTerm',
	//
	'filters',
	'organization',
	'allocationType',
	'status',
	//
	...additionalFilterFormFields,
	'more',
	//
	'actions',
] as const;
